export const WHATSAPP_NUMBER = "12092103187";

export const whatsappMessages = {
  default: "Hi, I'm interested in learning more about your IT courses. Can you help me?",
  course: (courseName: string) =>
    `Hi, I'm interested in the ${courseName} course at Seasoft Classes. Can you share more details?`,
  enroll: (courseName: string) =>
    `Hi, I'd like to enroll in the ${courseName} course. Please guide me on next steps.`,
  counseling: "Hi, I'd like to book a free career counseling session with Seasoft Classes.",
  jobs: "Hi, I'm looking for IT job opportunities through Seasoft Classes. Can you help?",
  corporate: "Hi, I'm interested in corporate IT training for my team at Seasoft Classes.",
  blog: (blogTitle: string) =>
    `Hi, I read your article "${blogTitle}" and I'm interested in related courses.`,
};

export const getWhatsAppURL = (message: string = whatsappMessages.default): string => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
};

export const openWhatsApp = (message: string = whatsappMessages.default): void => {
  if (typeof window !== "undefined") {
    const url = getWhatsAppURL(message);
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
